import React, { useEffect, useState } from 'react';
import { useSelectorContext, useSelectorState, useSelectorValue } from '../../common/providers/selectorProvider';
import FilterYear from '../../../../common/components/FilterYear';
import moment from 'moment';
import DropdownCheckboxV3 from '../../../../common/components/DropdownCheckboxV3';
import { getSelectedOption } from '../../../../common/utils';
import { useBUDeptGroupings } from '../hooks/values';
import {FIELD_BU, FIELD_DEPARTMENT} from "../dashboardDefinition";


export default function DepartmentSelector({ departmentMeta }) {
    const { departmentData } = useBUDeptGroupings()
    const [selectedDepartments, setSelectedDepartments] = useSelectorState(FIELD_DEPARTMENT, []) || [];

    const metric = useSelectorValue('metric') || 'sales';
    const canUseSelector = metric !== 'catchment_rate' && metric !== 'conversion_rate';

    const selectedBUGrps = useSelectorValue('bu_grp');
    const selectedBUs = useSelectorValue(FIELD_BU);

    const filteredDept =   selectedBUGrps?.length || selectedBUs?.length
    ? departmentData.filter((row) => {
        const bu_grp = row?.bu_grp;
        const business_unit_desc = row?.[FIELD_BU];
            return (selectedBUGrps?.length ? selectedBUGrps.includes(bu_grp) : true) &&
        (selectedBUs?.length ? selectedBUs.includes(business_unit_desc) : true)
    })
    : departmentData;

    const deptOptions = (filteredDept || [])
        .map((row) => {
            return {
                value: row?.[FIELD_DEPARTMENT],
                label: row?.[FIELD_DEPARTMENT],
            }
        })
        .filter((option) => option.value !== "" && option.label !== "")
        .sort((a, b) => a.label?.localeCompare(b.label));

    
    function handleSelectDept(data) {
        let result = data.map(a => a.value);
        setSelectedDepartments(result)
        return result
    }

    const hasLimitedOptions = !deptOptions || deptOptions.length <= 1

    const displayedValue = canUseSelector ?
        getSelectedOption(selectedDepartments, deptOptions) :
        [];

    return (
        <DropdownCheckboxV3
            id="department_filter"
            options={deptOptions}
            label="Department"
            limitTags={2}
            value={displayedValue || []}
            onChange={(event, newValue) => {
                handleSelectDept(getSelectedOption(newValue, deptOptions))
            }}
            disabled={!canUseSelector || hasLimitedOptions}
        />
    )
}